import React from "react";
import Layout from "../Layout";
import Form from "./form";
import useApi from "Hooks/Admin/useApi";
import useError from "Hooks/useError";
import { message } from "constants/message";
import { withRouter } from "react-router";

function CollectionThemeCreate(props) {
  const { request } = useApi();
  const stateError = useError();
  const messages = message();

  React.useEffect(() => {
    document.title = "Buzz Finder Admin - 絞り込みテーマ登録";
  }, []);

  const handleSubmit = (collectionTheme) => {
    let data = {
      name: collectionTheme.themeName,
      desc: collectionTheme.summary,
      word_type: "filter",
      words: collectionTheme.keywords
        .split("\n")
        .map((line) => line.trim())
        .filter((line) => line.length > 0),
    };

    request({
      method: "POST",
      url: `admin/keywords`,
      data: data,
    })
      .then(() => {
        stateError.initialize();
        props.history.push("/admin/collectionthemes?success=create");
      })
      .catch(() => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  return (
    <Layout
      content={
        <Form
          submit={handleSubmit}
        />
      }
    />
  );
}

export default withRouter(CollectionThemeCreate);
